__turbopack_context__.v({
  "list": "-2cdDG_list",
});
